export const locale = {
    "lang": "en",
    "data": {
        "MAPP-HOME": { //mandatory - microapp context
            "HELLO": "HELLO WORLD HOME"
        }
    }
}